module.exports = __webpack_public_path__ + "img/icon-phone.27e6c11d.svg";